/**
 * @author NikolaV
 */
import * as React from 'react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { DocumentsImagesStoreAbstract } from '@shared/documents-images/DocumentsImagesStoreAbstract';
import { DateRangePicker } from '@shared/ui-react/DateRangePicker';
import { CheckboxListDropdown } from '@shared/ui-react/CheckboxListDropdown';
import { FiletreeSelectReact } from '@shared/ui-react/FiletreeSelectReact';
import { Catch } from '@shared/ui-react/Catch';
import { PropertiesFillComponent } from '@pages/files/dialogs/PropertiesFillDialog';
import { ProgressSpinner } from 'primereact/progressspinner';


@observer
export class DocumentsImagesFilter extends React.Component<{
    treeData: ITreeData,
    store: DocumentsImagesStoreAbstract<any>
    visiblePresetsCount?: number;
    onClickFitView?: Function;
    mobile?: boolean;
    type: 'images' | 'documents';
}> {
    @observable activeDatePreset = 0;

    static defaultProps = {
        visiblePresetsCount: 5,
        mobile: false
    };

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    render() {
        const store = this.props.store;

        return (
            <div className='app__common-filters__wrapper' style={{ overflow: this.props.mobile ? 'auto' : 'hidden'}}>
                <main>
                    <div>
                        <label style={{ marginBottom: '1em' }} className='checkbox-label'>
                            <input type='checkbox'
                                   checked={store.filter.showOnMap}
                                   onChange={this.toggleShowOnMap}/>
                            <span>{__(`js_map.show_${this.props.type}_on_map`)}</span>
                        </label>
                    </div>

                    <DateRangePicker store={store.filter} onChange={store.setDates} visiblePresetsCount={this.props.visiblePresetsCount} mobile={this.props.mobile} clearable={true}/>

                    <div className='filters-row' style={{ alignItems: 'end' }}>
                        <div className='flex-column' style={{ overflow: 'hidden', flexShrink: 1 }}>
                            <span className='text-nowrap ellipsis'>{__('general.name')} / {__('general.description')}</span>
                            <input type='text' value={store.filter.text} onChange={this.handleFreeTextChange}/>
                        </div>

                        <div className='flex-column' style={{ minWidth: 90 }}>
                            <span>{__('general.type')}</span>
                            <select value={store.filter.type} onChange={this.handleTypeChange}>
                                <option value=''>{__('general.all')}</option>
                                <option value='no_location'>{__('js_images.filter.no_location')}</option>
                                {this.props.type === 'images' && <option value='panorama'>{__('js_images.panorama')}</option>}
                            </select>
                        </div>
                    </div>

                    <div className='filters-row' style={{ alignItems: 'end' }}>
                        <div className='flex-column'>
                            <span className='text-nowrap ellipsis'>{__('general.user')}</span>
                            <CheckboxListDropdown list={store.creators} onChange={this.handleCreatorChange} selected={store.filter.userIds}/>
                        </div>
                    </div>

                    {this.props.type === 'images' &&
                        <Catch>
                            <div className='filters-row' style={{ alignItems: 'end' }}>
                                <div className='flex-column'>
                                    <span className='text-nowrap ellipsis'>{__('general.alignment')}</span>
                                    <FiletreeSelectReact
                                        formFieldName='activeAlignment' selectable='file'
                                        treeData={this.props.treeData}
                                        selectedId={store.filter.alignmentId}
                                        hideEmptyFolders={true}
                                        canClearValue={true}
                                        showSelectedIcon={true}
                                        onChange={id => store.filter.alignmentId = parseInt(id) > 0 ?  parseInt(id) : null}
                                        childFilter={this.alignmentChildFilter}
                                    />
                                </div>
                            </div>
                        </Catch>
                    }

                    <div className='filters-row' style={{ alignItems: 'end' }}>
                        <div className='flex-column'>
                            <div className='flex-row ai-center gap-half' style={{ height: 14, overflow: 'hidden'}}>
                                <span className='text-nowrap ellipsis'>{__('js_properties.properties')}</span>
                                {this.props.store.isLoadingPropertiesFilter &&
                                    <span style={{ marginTop: 2}}><ProgressSpinner style={{width: '14px', height: '14px'}} strokeWidth="6" animationDuration="2s" /></span>
                                }
                            </div>
                            <div style={{ maxWidth: 360 }}>
                                <PropertiesFillComponent
                                    ref={el => null}
                                    maxHeight={this.props.mobile ? 'auto' : 200}
                                    manualAddDelete={true}
                                    showInfoColumns={false}
                                    fetchAvailableProperties={this.fetchProperties}
                                    fillValues={this.props.store.filter.properties}
                                    onFillValuesChanged={this.props.store.setPropertiesFilter}
                                    logicSwitches={this.props.store.filter.propertiesLogicSwitches}
                                    onLogicSwitchChanged={this.props.store.setPropertyLogicSwitch}
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    fetchProperties = () => Promise.resolve(this.props.store.documentProperties)

    handleFreeTextChange = e => this.props.store.filter.text = e.currentTarget.value;

    handleCreatorChange = (activeIds: string[]) => {
        this.props.store.filter.userIds = activeIds.map(e => parseInt(e));
    }

    handleTypeChange = e => this.props.store.filter.type = e.currentTarget.value;

    toggleShowOnMap = () => {
        this.props.store.filter.showOnMap = !this.props.store.filter.showOnMap;
    };

    alignmentChildFilter = item => {
        if (item.tolerance) return true;
        return kuuraModel.isAlignment(item);
    }
}

